import { forwardRef } from 'react';
import TableBaseButton from './TableBaseButton';

interface EditButtonProps {
  onClick: (editingRowIndex: number | null) => void;
  editingRowIndex: number | null;
  ref?: React.Ref<HTMLButtonElement>;
  onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
}

const EditButton = forwardRef<HTMLButtonElement, EditButtonProps>(
  ({ onClick, editingRowIndex, onKeyDown }, ref) => {
    return (
      <TableBaseButton
        onClick={() => onClick(editingRowIndex)}
        variant="primary"
        buttonText="編集"
        ref={ref}
        onKeyDown={onKeyDown}
      />
    );
  }
);

EditButton.displayName = 'EditButton';
export default EditButton;
